<template>
  <div style="min-height: 750px;" v-if="d_usrBillWdm">
    <template>
      <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
        <b-col sm="12" md="2" lg="2"> </b-col>
        <b-col sm="12" md="4" lg="4">
          <i class="fa fa-file-text-o"></i>
          {{ StoreLangTranslation.data['bills'][StoreLang] }}
        </b-col>
        <b-col sm="12" md="4" lg="4"></b-col>
        <b-col sm="12" md="2" lg="2"></b-col>
      </b-row>
      <b-row style="font-size: 16px;">
        <b-col sm="12" lg="2"></b-col>
        <b-col sm="12" lg="8">
          <b-row>
            <b-col sm="12" lg="4">
              <!-- <strong>{{ d_usrBillWdm['0']['parameters']['19']['name']['translation'][StoreLang] }}</strong> -->
              <strong>id</strong>
            </b-col>
            <b-col sm="12" lg="2">
              <strong>{{ d_usrBillWdm['0']['parameters']['32']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="2">
              <strong>{{ d_usrBillWdm['0']['parameters']['2']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="2">
              <strong>{{ d_usrBillWdm['0']['parameters']['20']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="2">
              <strong>{{ d_usrBillWdm['0']['parameters']['21']['name']['translation'][StoreLang] }}</strong>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" lg="2"></b-col>
      </b-row>
      <b-row style="font-size: 16px;" v-for="user_bill in d_userBills">
        <b-col sm="12" lg="2"></b-col>
        <b-col sm="12" lg="8">
          <b-row>
            <b-col sm="12" lg="4">
              <!-- {{ user_bill['data']['0']['19']['val']}} -->
              {{ user_bill['client_id']}}
            </b-col>
            <b-col sm="12" lg="2">
              {{ user_bill['data']['0']['32']['val']}} {{ d_usrBillWdm['0']['parameters']['29'].options[user_bill['data']['0']['29']['val']['value']].translation[StoreLang] }}
            </b-col>
            <b-col sm="12" lg="2">
              {{ user_bill['data']['0']['2']['val'].replaceAll("-", "/").replace("T", " ").split('.')[0]}}
            </b-col>
            <b-col sm="12" lg="2">
              <template v-if="user_bill['data']['0']['20'] && user_bill['data']['0']['20']['val']">
                <i class="fa fa-file-pdf-o" style="color: blue; cursor: pointer;" @click="f_startDocumentDownload(user_bill['data']['0']['20']['val'])"></i>
              </template>
            </b-col>
            <b-col sm="12" lg="2">
              <template v-if="user_bill['data']['0']['21'] && user_bill['data']['0']['21']['val']">
                <i class="fa fa-file-code-o" style="color: blue; cursor: pointer;" @click="f_startDocumentDownload(user_bill['data']['0']['21']['val'])"></i>
              </template>
            </b-col>
          </b-row>
          <!-- {{ user_bill }} -->
        </b-col>
        <b-col sm="12" lg="2"></b-col>
      </b-row>
    </template>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';

import { API_BASE_URL } from '@/config';
import { ServiceFunctions } from '@/wam/modules/service';
import { ClsWdm } from '@/wam/modules/wdm';
import { WisdomRegex } from '@/public/WisdomRegex';
import store from '@/store';
import {
  default as Page404
} from '@/wam/components/widgets/Page404';
import {
  default as Login
} from '@/wam/views/login';
import { mapGetters } from 'vuex';
export default {
  name: 'user_bills',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreLang: 'StoreLang',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreMenuData: 'StoreMenuData',
    StoreLangList: 'StoreLangList',
  }),
    components: {
    Page404,
    Login,
  },
  props: {},
  data () {
    return {
      d_usrBillWdm: '',
      d_userBills: [],
      d_user: '',
      d_billsLoading: false,

    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_bill').then(resp_wdm_data => { this.d_usrBillWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.f_listUserBills();
  },
  beforeMount () {},
  mounted: function () {},
  methods: {
    f_startDocumentDownload: function (document_id) {
      let query = 'user_client_id=' + this.d_user['username'];
      query += '&document_id=' + document_id;
      let data = {};
      ServiceFunctions.document_get_from_db(query, data)
        .then(resp => {
          if (resp.data.doc && resp.data.doc_extension) {
            let file_name = 'bill.' + resp.data.doc_extension;
            this.f_downloadDocument(resp.data.doc, file_name)
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    f_downloadDocument: function (base64_file, base64_file_name) {
      // console.log("base64_file ", base64_file);
      // console.log("base64_file_name ", base64_file_name);
      function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return bytes;
      }

      var saveByteArray = (function () {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        return function (data, name) {
          var blob = new Blob(data, { type: "octet/stream" }),
            url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
        };
      }());
      var sampleBytes = base64ToArrayBuffer(base64_file);
      saveByteArray([sampleBytes], base64_file_name);
    },
    f_listUserBills: function () {
      let query = 'user_client_id=' + this.d_user['username'];
      let data = {};
      this.d_billsLoading = true;
      ServiceFunctions.user_bill_list(query, data)
        .then(resp => {
          this.d_billsLoading = false;
          // console.log("resp.data")
          // console.log(resp.data)
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_userBills = resp.data.list;
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch:{}
}

</script>

